// src/pages/seo/components/SiteTab.tsx

import React from 'react';
import { FieldWithAI } from './FieldWithAI';
import { toast } from '@/hooks/use-toast';

export function SiteTab({ data, save, ai, pin, onDirtyChange }:{ data:any; save:(patch:any)=>void; ai:(k:string,c:any)=>Promise<string>; pin:string; onDirtyChange?: (dirty: boolean) => void; }){
  const [state, setState] = React.useState(()=>({
    brand: data?.settings?.brand || '',
    tagline: data?.settings?.tagline || '',
    default_meta_desc: data?.settings?.default_meta?.desc || ''
  }));
  const [isDirty, setIsDirty] = React.useState(false);

  React.useEffect(() => {
    const hasChanges = 
      state.brand !== (data?.settings?.brand || '') ||
      state.tagline !== (data?.settings?.tagline || '') ||
      state.default_meta_desc !== (data?.settings?.default_meta?.desc || '');
    setIsDirty(hasChanges);
  }, [state, data]);

  React.useEffect(() => {
    onDirtyChange?.(isDirty);
  }, [isDirty, onDirtyChange]);

  React.useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);

  function onUndo() { /* history wiring in save() */ }
  function onChange(k:string,v:any){ setState(s=>({...s,[k]:v})); }
  return (
    <div className="space-y-4">
      <FieldWithAI label="Brand" fieldKey="site.brand" value={state.brand} onChange={v=>onChange('brand',v)} aiSuggest={(k,c)=>ai(k,{...c,brand:state.brand})} context={{}} onUndo={onUndo} previous={data?.settings?.brand} />
      <FieldWithAI label="Tagline" fieldKey="site.tagline" value={state.tagline} onChange={v=>onChange('tagline',v)} aiSuggest={(k,c)=>ai(k,{...c,brand:state.brand})} context={{}} onUndo={onUndo} previous={data?.settings?.tagline} />
      <FieldWithAI label="Default Meta Description" fieldKey="site.default_meta.desc" value={state.default_meta_desc} onChange={v=>onChange('default_meta_desc',v)} aiSuggest={(k,c)=>ai(k,{...c,brand:state.brand})} context={{}} onUndo={onUndo} previous={data?.settings?.default_meta?.desc} />
      <div className="pt-2">
        <button 
          className="rounded px-4 py-2 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" 
          disabled={!isDirty}
          onClick={()=>{
            save({ settings: { brand: state.brand, tagline: state.tagline, default_meta: { desc: state.default_meta_desc } } });
            setIsDirty(false);
            toast({
              title: "Settings saved",
              description: "Site settings have been saved successfully.",
            });
          }}
        >
          {isDirty ? 'Save Site Settings' : 'Saved'}
        </button>
      </div>
    </div>
  );
}